/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Player { 
    readonly id: string;
    name: string;
    /**
     * Indicates if this player is a gamemaster in the campaign
     */
    gameMaster?: boolean;
}

